// import {useContext} from "react"
// import Navbar from './components/navbar/navbar'
// import Intro from './components/intro/intro'
// import './App.css'
// import {themeContext} from './Context'
// import Servicess from "./components/Services/Servicess"
// import Work from "./components/work/work"
// import About from './components/About/about'
// import Contact from './components/contact/contact'
// import Github from './components/gitState/github'
// function App() {
//   let theme = useContext(themeContext)
//   let darkMode = theme.state.darkMode
 
//   return (
//     <div className="App" style={{background: darkMode? "black" : 'white', color : darkMode? "white": ''}}>
//       <Navbar/>
//       <Intro/>
//       <Servicess/>
//       <Work/>
//       <About/>
//       <Github/>
//       <Contact/>
//     </div>
//   );
// }

// export default App;


import './App.css';
import Navbar from "./nav/nav"
import Side from "./sideContacts/side";
import Home from './home/home';
import Projects from "./projects/projects"
import Skills from "./skills/skill"
import Github from "./github/gitstats";
import Contact from "./contact/contact";
import Footer from "./footer/footer";
import { Box } from '@chakra-ui/react';
import { themeContext } from './context/Context';
import { useContext } from 'react';
function App() {
  const theme = useContext(themeContext);
  const darkmode = theme.state.darkMode
  return (
    <Box className="App" style={{
      backgroundColor: darkmode ? "rgb(54, 53, 53)" : "rgb(217, 235, 252)",
      color: darkmode ? "rgb(240, 231, 231)" : "black"
    }}>
      <Navbar />
      {/* <Fade duration="1000"> */}
      <Side />
      <br /><br /><br /><br /><br /><br />
      <Home />
      <br /><br /><br /><br />
      <Projects />
      <br /><br /><br /><br /><br /><br />
      <Skills />
      <br /><br /><br /><br /><br /><br />
      <Github />
      <br /><br /><br /><br /><br /><br />
      <Contact />
      <br /><br /><br /><br /><br /><br />
      <Footer />
    </Box>
  );
}

export default App;

